import { FixedOptionSelectInput, type FixedOptionSelectInputProps } from '../fixed-option-select-input/fixed-option-select-input';
import { type BaseEnumOptionInputProps, useEnumFixedOptionInputProps } from './shared';

export type EnumSelectInputProps<TEnum extends Record<string, TValue>, TValue extends string = string> = Omit<
  FixedOptionSelectInputProps<TValue>,
  'i18nPrefix' | 'i18nValueName' | 'optionValues'
> &
  BaseEnumOptionInputProps<TEnum, TValue>;

export function EnumSelectInput<TEnum extends Record<string, TValue>, TValue extends string = string>({
  enumValue,
  enumName,
  ...rest
}: EnumSelectInputProps<TEnum, TValue>) {
  const enumValues = useEnumFixedOptionInputProps<TEnum, TValue>({ enumName, enumValue });

  return <FixedOptionSelectInput<TValue> {...enumValues} {...rest} />;
}
